import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { actions } from '@common/redux/modules/Actions';
import { initialState } from '@common/redux/reducers/SearchConditionReducer';
import { AgencyAppState } from '../../../redux/modules/store';
import SideNav from '../../../component/organisms/SideNav';
import { initialCurrentFilterState } from '@common/redux/reducers/CurrentFilterReducer';
import { initialFilterLinkedDataState } from '@common/redux/reducers/FilterLinkedDataReducer';

/* istanbul ignore next */
const mapStateToProps = (appState: AgencyAppState) => {
  return {
    userName: appState.loginUser.crewName,
    stores: appState.loginUser.stores || [],
    targetStores: appState.loginUser.browsableStores || [],
    // targetStores: Object.values(appState.storeSelector.stores ?? {}).map((store) => store.agencyCd),
  };
};

/* istanbul ignore next */
const mapDispatchToProps = (dispatch: Dispatch) => {
  return {
    //検索条件とフィルター条件を初期化する
    clearSearchCondition: () => {
      clearSearchCondition(dispatch);
    },
    clearLocationPathAndFilterCondition: () => {
      clearLocationPathAndFilterCondition(dispatch);
    },
    updateHistoryLocationPathName: (pathname: string) => {
      updateHistoryLocationPathName(dispatch, pathname);
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideNav);

/**
 * 検索条件の初期化
 * 検索条件と、設定中のフィルターを初期化する
 * @param dispatch
 */
export function clearSearchCondition(dispatch: Dispatch): void {
  dispatch(actions.updateSearchCondition(initialState));
  dispatch(actions.updateCustomerListSearchCondition.init());
  dispatch(actions.updateCurrentFilter(initialCurrentFilterState));
  dispatch(actions.filterLinkedData.updateFilterCondition(initialFilterLinkedDataState));
  dispatch(actions.locationHistory.resetData());
}

export function clearLocationPathAndFilterCondition(dispatch: Dispatch): void {
  dispatch(actions.filterLinkedData.updateFilterCondition(initialFilterLinkedDataState));
  dispatch(actions.locationHistory.resetData());
}

export function updateHistoryLocationPathName(dispatch: Dispatch, pathname: string): void {
  dispatch(actions.locationHistory.updatePathName(pathname));
}
